import { getOnecomConfig } from "../../selectors";

import { openModal } from "../openModal/openModal";

export const loadCountryRestrictions = (country) => {
  return (dispatch, getState, { api }) => {
    const { countryCode } = getOnecomConfig(getState());
    const customerCountry = country || countryCode;

    return api.getCountryRestrictions(customerCountry).then(
      (data) => {
        const isExchangeRestricted = data.includes("EXCHANGE_NOT_ALLOWED");

        if (isExchangeRestricted) {
          dispatch(
            openModal("ExchangeWarning", {
              data: { countryCode: customerCountry },
            }),
          );
        }
        return { wasSuccessful: true, isExchangeRestricted };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
